import axios from "@app/Security/AxiosAuthentication";
import ApiEndpoints from '@app/utils/ApiEndpoints';
import BlueDotInterface from '@app/Interface/Report/BlueDotInterface';
import SmartTestInterface from '@app/Interface/Report/SmartTestInterface';
import DegradesInterface from '@app/Interface/Report/DegradesInterface';
import MemberEquityInterface from '@app/Interface/Report/MemberEquityInterface';
import HistoricalQualityComponentInterface from '@app/Interface/HistoricalQualityComponentInterface';
import QualityComponentInterface from '@app/Interface/QualityComponentInterface';
import MontanaPriceHistoryInterface from "@app/Interface/MontanaPriceHistoryInterface";
import CoopPriceHistoryInterface from "@app/Interface/CoopPriceHistoryInterface";
import ContractInterface from "@app/Interface/Report/ContractInterface";
import PayrollHeaderInterface from "@app/Interface/Report/PayrollHeaderInterface";
import PayrollLinesInterface from "@app/Interface/Report/PayrollLinesInterface";
import DailyAverageProductionBaseInterface from "@app/Interface/Report/DailyAverageProductionBaseInterface";
import DataTableUpdateInterface from "@app/Interface/DataTableUpdateInterface";
import moment from "moment-timezone";
import RollbarHelper from "@app/utils/RollbarHelper";
import DDCPayrollHeaderInterface from "@app/Interface/Report/DDCPayrollHeaderInterface";

export default class ReportDataHelper {
    static getBlueDotData = async (controller: AbortController, fpuId: number, pageId: number): Promise<BlueDotInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.BLUE_DOT_REPORT + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: BlueDotInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getBlueDotData()");
        }

        return data;
    }

    static getSmartTestData = async (controller: AbortController, fpuId: number, pageId: number): Promise<SmartTestInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.SMART_TEST_REPORT + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: SmartTestInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getSmartTestData()");
        }

        return data;
    }

    static getDegradesData = async (controller: AbortController, fpuId: number, pageId: number): Promise<DegradesInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.DEGRADES_REPORT + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: DegradesInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getDegradesData()");
        }

        return data;
    }

    static getMemberEquityData = async (controller: AbortController, fpuId: number, pageId: number): Promise<MemberEquityInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.MEMBER_EQUITY_REPORT + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: MemberEquityInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getMemberEquityData()");
        }

        return data;
    }

    static getHistoricalQualityComponentsData = async (controller: AbortController, fpuId: number, pageId: number): Promise<HistoricalQualityComponentInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.HISTORICAL_QUALITY_COMPONENTS + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: HistoricalQualityComponentInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getHistoricalQualityComponentsData()");
        }

        return data;
    }

    static historicalQualityComponentHasLpcData = (items: HistoricalQualityComponentInterface[]): boolean => {

        const hasData = items.some(item => item.lpcavg > 0);

        return hasData;

    }

    static getMontanaPriceHistoryData = async (fpuId: number, pageId: number): Promise<MontanaPriceHistoryInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.MONTANA_PRICE_HISTORY + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: MontanaPriceHistoryInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getMontanaPriceHistoryData()");
        }

        return data;
    }

    static getCoopPriceHistoryData = async (fpuId: number, pageId: number): Promise<CoopPriceHistoryInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.COOP_PRICE_HISTORY + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: CoopPriceHistoryInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getCoopPriceHistoryData()");
        }

        return data;
    }

    static getPayrollListData = async (controller: AbortController, fpuId: number, pageId: number, monthStart = '', monthEnd = '', range: '' | 'before' | 'after' | 'outside' = ''): Promise<PayrollHeaderInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        let endPoint: string = ApiEndpoints.PAYROLL_LIST + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";
        if (monthStart) {
            endPoint += `&month_start=${monthStart}`;
        }
        if (monthEnd) {
            endPoint += `&month_end=${monthEnd}`;
        }
        if (range) {
            endPoint += `&range=${range}`;
        }

        const url = baseUrl + endPoint;
        let data: PayrollHeaderInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getPayrollListData()");
        }

        return data;
    }

    static getDDCPayrollListData = async (controller: AbortController, fpuId: number, pageId: number): Promise<DDCPayrollHeaderInterface[]> => {
        const baseUrl: string = process.env.API_BASEURL ?? "";

        let endpoint: string = ApiEndpoints.DDC_PAYROLL_HEADERS + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endpoint;
        let data: DDCPayrollHeaderInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getDDCPayrollListData()");
        }

        return data;
    }

    static getPayrollDetailsData = async (controller: AbortController, fpuId: number, pageId: number, payrollId: number): Promise<PayrollLinesInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.PAYROLL_DETAILS + `?page=1&fpu_id=${fpuId}&page_id=${pageId}&payroll_id=${payrollId}` ?? "";

        const url = baseUrl + endPoint;
        let data: PayrollLinesInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getPayrollDetailsData()");
        }

        return data;
    }

    static getEStatementsData = async (fpuId: number, pageId: number, startDate: string, endDate: string): Promise<QualityComponentInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        let endPoint: string = ApiEndpoints.QUALITY_COMPONENTS + `?page=1&fpu_id=${fpuId}&page_id=${pageId}`;
        endPoint += '&report_type=e-statements';
        endPoint += `&pickup_date_start=${startDate}`;
        endPoint += `&pickup_date_end=${endDate}`;

        const url = baseUrl + endPoint;
        let data: QualityComponentInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getEStatementsData()");
        }

        return data;
    }

    static getContractData = async (controller: AbortController, fpuId: number, pageId: number, closed = false): Promise<ContractInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        let endPoint: string = closed ? ApiEndpoints.CLOSED_CONTRACTS : ApiEndpoints.OPEN_CONTRACTS;
        endPoint += `?page=1&fpu_id=${fpuId}&page_id=${pageId}`;

        const url = baseUrl + endPoint;
        let data: ContractInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getContractData()");
        }

        return data;
    }

    static getDailyAverageProductionBaseData = async (controller: AbortController, fpuId: number, pageId: number): Promise<DailyAverageProductionBaseInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.DAILY_AVERAGE_PRODUCTION + `?page=1&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: DailyAverageProductionBaseInterface[] = [];

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getDailyAverageProductionBaseData()");
        }

        return data;
    }

    static getTableUpdatedText = async (controller: AbortController, table: string): Promise<string> => {
        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.TABLE_UPDATES ?? "";

        const url = baseUrl + endPoint;
        let text = '';

        try {
            const response = await axios.get(url, {
                withCredentials: true,
                signal: controller.signal,
                headers: {
                    "Accept": "application/json"
                }
            });
            const lowercaseTargetTable = table.toLowerCase();
            const allTablesUpdateData: DataTableUpdateInterface[] = response.data;
            // NOTE: The case of table names returned from this endpoint isn't always the same as the actual table name,
            // so we're comparing the lowercase versions against each other to account for this.
            const tableUpdateData: DataTableUpdateInterface | undefined = allTablesUpdateData.find(
                update => update.tableName.toLowerCase() === lowercaseTargetTable
            );
            if (tableUpdateData) {
                // NOTE: The lastLoaded datetime is saved to the DB as Pacific time, but Symfony assumes it's UTC.
                // So we're stripping the timezone info out of the date and making sure moment knows this should be Pacific time
                text = `last updated ${moment.tz(tableUpdateData.lastLoaded.split('+')[0], 'America/Los_Angeles').calendar(null, {
                    lastDay: '[yesterday at] LT zz',
                    sameDay: '[today at] LT zz',
                    nextDay: '[tomorrow at] LT zz',
                    lastWeek: '[last] dddd [at] LT zz',
                    nextWeek: 'dddd [at] LT zz',
                    sameElse: 'MMM DD [at] h:mm A zz'
                })}`;
            }
        } catch (error) {
            RollbarHelper.logRequestError(error, "getTableUpdatedText()");
        }

        return text;
    }

    static getReportPdfUrl = (
        reportType: string,
        fpuId: number,
        settlementMonthYear?: string,
        payrollId?: number,
        eStatementEndDate?: string
    ): string => {
        const baseUrl: string = process.env.API_BASEURL ?? "";

        // NOTE: The jsonld extension is required for the PDF to download when the user goes to this URL
        let endPoint: string = ApiEndpoints.REPORT_PDF + `.jsonld?report_type=${reportType}&fpu=${fpuId}`;

        if (
            (reportType === 'fcp-settlements' || reportType === 'fcp-settlements-letter') &&
            settlementMonthYear
        ) {
            endPoint += `&month_year=${settlementMonthYear}`;
        }

        if (reportType === 'payroll' && payrollId) {
            endPoint += `&payroll=${payrollId}`;
        }

        if (reportType === 'e-statements' && eStatementEndDate) {
            endPoint += `&end_date=${eStatementEndDate}`;
        }

        return baseUrl + endPoint;
    }

}
